let host = location.host.split(":")[0];
export const environment = {
  production: false,
  // apiUrl: 'http://' + host + ':3000/',
  apiUrl: 'https://api.staging.ownly.com.au/api/',
  // apiUrl: 'http://localhost:5095/api/',
  // apiUrl: 'http://192.168.1.20:5095/api/',
  // apiUrl: 'http://portal.syncitt.world:5095/api/',
  // apiUrl: 'https://portal.ownly.com.au:5095/api/',
  // apiUrl: 'http://13.54.34.150:5095/api/',
  // user_id:"5a8a9655d58b1a1468583494",
  // imageUrl: 'http://localhost:5095/',
  // imageUrl: 'http://192.168.100.23:5095/',
  // portalURL: 'http://portal.syncitt.world/',
  // imageUrl: 'https://portal.staging.ownly.com.au:5095/',
  imageUrl: 'https://api.staging.ownly.com.au/',
  portalURL: 'https://portal.staging.ownly.com.au/',
  picturesUrl: 'https://s3-us-west-2.amazonaws.com/healingshore/',
  google_api_key: 'AIzaSyArn8aRuotTEwoxDitgJNXKNU77vhA-fwA',
  google_code: 'G-1BR9CM0WHN'
};
